import { render, staticRenderFns } from "./AvailableRegisterModal.vue?vue&type=template&id=887bc384&scoped=true"
import script from "./AvailableRegisterModal.vue?vue&type=script&lang=ts"
export * from "./AvailableRegisterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887bc384",
  null
  
)

export default component.exports